export default __webpack_public_path__ + "static/media/logo-written.3cc2dced.png";